import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { MainLayout } from './layout/main-layout/main-layout';

@Component({
  selector: 'app-root',
  imports: [MainLayout],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  ngOnInit(): void {
    // Hide the loading spinner once Angular is ready
    const loadingElement = document.getElementById('app-loading');
    if (loadingElement) {
      loadingElement.classList.add('hidden');
      // Remove from DOM after transition completes
      setTimeout(() => {
        loadingElement.remove();
      }, 300);
    }
  }
}
